import { 
	GET_STORE_OVERALLS, 
	GET_STORE_OVERALL,
	CREATE_STORE_OVERALL,
	UPDATE_STORE_OVERALL,
	DESTROY_STORE_OVERALL,
	MOVE_STORE_OVERALLS
} from "./actions"

export function StoreOverallsReducer(state = {}, action) {
	switch (action.type) {
		case `${MOVE_STORE_OVERALLS}_FULFILLED`:
		case `${GET_STORE_OVERALLS}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_STORE_OVERALL}_FULFILLED`:
		case `${CREATE_STORE_OVERALL}_FULFILLED`:
		case `${UPDATE_STORE_OVERALL}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_STORE_OVERALL}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { StoreOverallsReducer } from "modules/store/overalls/reducer"

// store_overalls:StoreOverallsReducer,
